import config from "config/config";

export const getUnauthCustomerPrechatInfo = (portalChatID, prechatFormData) => {
  return {
    extraPrechatInfo: [
      {
        entityName: "Contact",
        showOnCreate: false,
        entityFieldMaps: [
          {
            isExactMatch: true,
            fieldName: "FirstName",
            doCreate: false,
            doFind: false,
            label: "First Name",
          },
        ],
      },
      {
        entityName: "Case",
        showOnCreate: true,
        entityFieldMaps: [
          ...(config.ENABLE_POST_CHAT_SURVEY === "true"
            ? [
                {
                  isExactMatch: true,
                  fieldName: "CRM_Portal_Chat_ID__c",
                  doCreate: true,
                  doFind: false,
                  label: "Portal Chat ID",
                },
              ]
            : []),
          {
            isExactMatch: true,
            fieldName: "CRM_Caller_Name__c",
            doCreate: true,
            doFind: false,
            label: "Caller Name",
          },
          {
            isExactMatch: true,
            fieldName: "CRM_Caller_Type__c",
            doCreate: true,
            doFind: false,
            label: "Caller type",
          },
          {
            isExactMatch: true,
            fieldName: "CRM_Caller_Email__c",
            doCreate: true,
            doFind: false,
            label: "Contact Email",
          },
          {
            isExactMatch: true,
            fieldName: "GiDP_CarrierName__c",
            doCreate: true,
            doFind: false,
            label: "Carrier Name",
          },
          {
            isExactMatch: true,
            fieldName: "GiDP_CarrierCode__c",
            doCreate: true,
            doFind: false,
            label: "Carrier Code",
          },
        ],
      },
    ],
    extraPrechatFormDetails: [
      ...(config.ENABLE_POST_CHAT_SURVEY === "true"
        ? [
            {
              label: "Portal Chat ID",
              value: portalChatID,
              transcriptFields: [],
              displayToAgent: true,
            },
          ]
        : []),
      {
        label: "First Name",
        value: prechatFormData.name,
        transcriptFields: [],
        displayToAgent: true,
      },
      {
        label: "Caller Name",
        value: prechatFormData.name,
        transcriptFields: [],
        displayToAgent: true,
      },
      {
        label: "Caller type",
        value: "Customer",
        transcriptFields: [],
        displayToAgent: true,
      },
      {
        label: "Contact Email",
        value: prechatFormData.email,
        transcriptFields: [],
        displayToAgent: true,
      },
      {
        label: "Carrier Name",
        value: config.CLIENTNAME,
        transcriptFields: [],
        displayToAgent: true,
      },
      {
        label: "Carrier Code",
        value: config.COMPANY,
        transcriptFields: [],
        displayToAgent: true,
      },
    ],
  };
};
